import { render, staticRenderFns } from "./product-element.vue?vue&type=template&id=3148c386&scoped=true&"
import script from "./product-element.vue?vue&type=script&lang=js&"
export * from "./product-element.vue?vue&type=script&lang=js&"
import style0 from "./product-element.vue?vue&type=style&index=0&id=3148c386&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3148c386",
  null
  
)

export default component.exports